const OrderActions = ({ orderStatus, order, onCancel, onReorder }) => {
  const isRefunded = order?.payments?.paymentStatus === "refunded";

  if (orderStatus === "completed") {
    return (
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-2xl bg-green-50 border border-green-100 text-green-600 font-medium text-sm">
        <div className="w-2 h-2 rounded-full bg-green-500" />
        Order completed
      </div>
    );
  }

  if (orderStatus === "cancelled") {
    return (
      <div className="flex flex-wrap gap-3">
        {/* REFUNDED */}
        {isRefunded ? (
          <div className="w-full max-w-md">
            {/* Card */}
            <div
              className="
        relative overflow-hidden
        rounded-3xl
        border border-red-100
        bg-gradient-to-br from-red-50 via-white to-rose-50
        shadow-sm
      "
            >
              {/* Glow */}
              <div className="absolute top-0 right-0 w-40 h-40 bg-red-200/20 blur-3xl rounded-full" />

              <div className="relative p-5">
                {/* Top */}
                <div className="flex items-start gap-4">
                  {/* Icon */}
                  <div className="relative shrink-0">
                    <div className="w-14 h-14 rounded-2xl bg-red-100 flex items-center justify-center shadow-inner">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-7 h-7 text-red-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17 9V7a5 5 0 00-10 0v2m-2 0h14l-1 10H6L5 9z"
                        />
                      </svg>
                    </div>

                    {/* animated status */}
                    <div className="absolute -top-1 -right-1">
                      <div className="relative flex h-3 w-3">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>

                        <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-1">
                    <div className="flex items-center justify-between gap-3">
                      <h3 className="text-base font-bold text-navy">
                        Refund Completed
                      </h3>

                      <span className="px-2.5 py-1 rounded-full bg-red-100 text-red-600 text-[11px] font-bold uppercase tracking-wide">
                        Refunded
                      </span>
                    </div>

                    <p className="text-sm text-gray-500 mt-2 leading-relaxed">
                      This order cannot be reordered because the payment has
                      already been refunded to the customer.
                    </p>
                  </div>
                </div>

                {/* Divider */}
                <div className="my-5 border-t border-red-100" />

                {/* Disabled Button */}
                <button
                  disabled
                  className="
            w-full h-12
            rounded-2xl
            bg-gray-100
            border border-gray-200
            text-gray-400
            font-semibold text-sm
            cursor-not-allowed
            flex items-center justify-center gap-2
          "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M18.364 5.636l-12.728 12.728M5.636 5.636l12.728 12.728"
                    />
                  </svg>
                  Re-Order Disabled
                </button>
              </div>
            </div>
          </div>
        ) : (
          <button
            onClick={() => onReorder(order)}
            className="
      inline-flex items-center gap-2
      bg-gradient-to-r from-yellowstar to-yellowlight
      hover:brightness-105
      px-5 py-3
      rounded-2xl
      text-navy font-semibold text-sm
      shadow-md hover:shadow-lg
      transition-all duration-300
    "
          >
            Re-Order
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="flex gap-3">
      <button
        onClick={() => onCancel(order._id)}
        className="
          px-5 py-2.5
          rounded-2xl
          border border-navy/20
          bg-white hover:bg-navy
          text-navy hover:text-white
          font-medium text-sm
          shadow-sm hover:shadow-md
          transition-all duration-300
        "
      >
        Cancel Order
      </button>
    </div>
  );
};

export default OrderActions;
